function arrayToDict (array, key) {
  const result = {}
  for (let i = 0; i < array.length; i++) {
    result[array[i][key]] = array[i]
  }
  return result
}

/*
  Unit mutations
*/
export default {

  SET_LOADING (state, payload) {
    state.loading = payload
  },

  setEventList (state, payload) {
    // console.log(payload)
    // Sort payload
    state.eventList = payload
    state.eventDictList = {}
    const result = {}
    for (let i = 0; i < payload.length; i++) {
      if (result[payload[i].unitId]) {
        result[payload[i].unitId].push(payload[i])
      } else {
        result[payload[i].unitId] = []
        result[payload[i].unitId].push(payload[i])
      }
    }
    state.eventDictList = result
  },

  setCodeList (state, payload) {
    state.codeList = payload
    state.codeDictList = Object.assign({}, arrayToDict(payload, 'id'))
  },

  newItem (state, payload) {
    state.list.push(payload)
    state.dictList[payload.id] = payload
  },

  updateItem (state, payload) {
    const list = [...state.list]
    for (let i = 0; i < list.length; i++) {
      if (list[i].id.toString() === payload.id.toString()) {
        list[i] = Object.assign({}, payload)
      }
    }

    state.list = []
    state.list = [...list]
    state.dictList = Object.assign({}, arrayToDict(list, 'id'))
  },

  deleteItem (state, id) {
    const list = state.list.filter(item => item.id.toString() !== id.toString())
    state.list = []
    state.list = [...list]
    state.dictList = Object.assign({}, arrayToDict(list, 'id'))
  },

  setOdometersv2 (state, payload) {
    state.odometers[payload.interval] = payload.result
  },

  setUnitsToOdometers (state, { rootState }) {
    const units = rootState.units.dictList
    for (var key in state.odometers) {
      for (var i = 0; i < state.odometers[key].length; i++) {
        state.odometers[key][i].unit = units[state.odometers[key][i].unitId]
      }
    }
  },

  setOdometers (state, { rootState }) {
    const convertDateToCurrentTimezone = (date) => {
      date.setMinutes(date.getMinutes() + date.getTimezoneOffset())
      return date
    }
    const compareDates = (date, firstDate, endDate) => {
      return date >= firstDate && date <= endDate
    }

    const getStartOfDay = (date) => {
      date.setHours(0, 0, 0, 0)
      return date
    }

    const getEndOfDay = (date) => {
      date.setHours(23, 59, 59, 999)
      return date
    }

    const setToMonday = (date) => {
      const day = date.getDay() || 7
      if (day !== 1) {
        date.setHours(-24 * (day - 1)) 
      }
      return date
    }
    const today = []
    const yesterday = []
    const thisWeek = []
    const lastWeek = []
    const units = rootState.units.list
    // Init dates
    const baseDate = new Date()
    const todayStart = getStartOfDay(new Date())
    const todayEnd = getEndOfDay(new Date())
    const yesterdayStart = getStartOfDay(new Date((baseDate.getTime()) - 86400 * 1000))
    const yesterdayEnd = getEndOfDay(new Date((baseDate.getTime()) - 86400 * 1000))
    const thisWeekStart = setToMonday(getStartOfDay(new Date()))
    const lastWeekStart = setToMonday(getStartOfDay(new Date(new Date().getTime() - 86400 * 7 * 1000)))
    for (const i in units) {
      const dailyOdometerArray = Object.assign([], state.eventDictList[units[i].id])
      if (dailyOdometerArray.length > 0) {
        // Validate Today
        today.push({
          unit: units[i],
          distance: dailyOdometerArray.filter((odometer) => {
            return compareDates(convertDateToCurrentTimezone(new Date(odometer.date)), todayStart, todayEnd)
          }).reduce((a, b) => parseFloat(a) + parseFloat(b.distance), 0)
        })
        yesterday.push({
          unit: units[i],
          distance: dailyOdometerArray.filter((odometer) => {
            return compareDates(convertDateToCurrentTimezone(new Date(odometer.date)), yesterdayStart, yesterdayEnd)
          }).reduce((a, b) => parseFloat(a) + parseFloat(b.distance), 0)
        })
        thisWeek.push({
          unit: units[i],
          distance: dailyOdometerArray.filter((odometer) => {
            return compareDates(convertDateToCurrentTimezone(new Date(odometer.date)), thisWeekStart, todayEnd)
          }).reduce((a, b) => parseFloat(a) + parseFloat(b.distance), 0)
        })
        lastWeek.push({
          unit: units[i],
          distance: dailyOdometerArray.filter((odometer) => {
            return compareDates(convertDateToCurrentTimezone(new Date(odometer.date)), lastWeekStart, thisWeekStart)
          }).reduce((a, b) => parseFloat(a) + parseFloat(b.distance), 0)
        })
      } else {
        // Validate Today
        today.push({
          unit: units[i],
          distance: 0
        })
        yesterday.push({
          unit: units[i],
          distance: 0
        })
        thisWeek.push({
          unit: units[i],
          distance: 0
        })
        lastWeek.push({
          unit: units[i],
          distance: 0
        })
      }
    }
    state.odometers = {
      today: today,
      yesterday: yesterday,
      thisWeek: thisWeek,
      lastWeek: lastWeek
    }
  },
  // eslint-disable-next-line no-unused-vars
  toggle (_, payload) {}
}